import { CRUDEntity } from "../abstracts/CRUDEntity";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";


export const Vendor = (() => {
    return class Vendor  extends CRUDEntity {


        constructor(id=null) {

            Object.assign(Vendor.prototype, HasAttachments);

            super();
            this.entityClass = 'vendor';
            this.urlRoot = '/vendors';
            this.sectionRootUrl = '/vendors';
            this.id = id;
        }
    }
})();
